// import Dataset from '@/views/pages/metadata/dataset/index.vue';
// import DatasetAnalysis from '@/views/pages/metadata/datasetAnalysis/index.vue';
// import DataWheel from '@/views/pages/metadata/datawheel/index.vue';
// import MetaModel from '@/views/pages/metadata/metaModel/index.vue';
// import dataStandards from '@/views/pages/metadata/dataStandards/index.vue';
// import MetaOverview from '@/views/pages/metadata/metaOverview/index.vue';
// import FutureDataSet from '@/views/pages/metadata/futureDataSet/index.vue';
// import SourceSystem from '@/views/pages/metadata/sourceSystem/index.vue';
// import SourceSystemDetail from '@/views/pages/metadata/sourceSystemDetail/index.vue';
// import ChartsMap from '@/views/pages/metadata/chartsMap/index.vue';

const Dataset = () => import('@/views/pages/metadata/dataset/index.vue');
const DatasetAnalysis = () => import('@/views/pages/metadata/datasetAnalysis/index.vue');
const DataWheel = () => import('@/views/pages/metadata/datawheel/index.vue');
const MetaModel = () => import('@/views/pages/metadata/metaModel/index.vue');
const dataStandards = () => import('@/views/pages/metadata/dataStandards/index.vue');
const FutureDataSet = () => import('@/views/pages/metadata/futureDataSet/index.vue');
const FutureDataSetDetail = () => import('@/views/pages/metadata/futureDataSet/Detail.vue');
const SourceSystem = () => import('@/views/pages/metadata/sourceSystem/index.vue');
const SourceSystemDetail = () => import('@/views/pages/metadata/sourceSystemDetail/index.vue');
const DataMapV2 = () => import('@/views/pages/metadata/dataMapV2/index.vue');
const DataMap = () => import('@/views/pages/metadata/dataMap/index.vue');
const ChartsMap = () => import('@/views/pages/metadata/chartsMap/index.vue');
const DataBase = () => import('@/views/pages/metadata/metaDataBrowser/database/index.vue');
const DataBaseDetail = () => import('@/views/pages/metadata/metaDataBrowser/databaseDetail/index.vue');
const MetaDataTable = () => import('@/views/pages/metadata/metaDataBrowser/table/index.vue');
const MetaDataTableDetail = () => import('@/views/pages/metadata/metaDataBrowser/tableDetail/index.vue');
const DataAssetDetail = () => import('@/views/pages/metadata/datasetDetail/index.vue');

const MetaRouteList = [
  {
    path: 'datawheel',
    component: DataWheel,
    name: '/datawheel',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Data Category(Data Wheel)',
      mid: '6f81-c5a2',
    },
  },
  {
    path: 'dataasset',
    component: Dataset,
    name: '/dataasset',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Data Asset & Dataset',
      mid: 'b3d9-7e04',
    },
  },

  {
    path: 'futuredataset',
    name: '/futuredataset',
    component: FutureDataSet,
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Data Asset Requirement',
      mid: '1a8f-2c65',
    },
  },
  {
    path: 'futureDataSetDetail',
    name: '/futureDataSetDetail',
    component: FutureDataSetDetail,
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Data Asset Requirement Detail',
      mid: 'e7c4-9d03',
    },
  },
  {
    path: 'datasetAnalysis',
    component: DatasetAnalysis,
    name: '/datasetAnalysis',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'datasetAnalysis',
      mid: '4f6b-a8d1',
    },
  },
  {
    path: 'sourceSystem',
    component: SourceSystem,
    name: '/sourceSystem',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Application',
      mid: '0d59-7e2c',
    },
  },
  {
    path: 'sourceSystemDetail',
    component: SourceSystemDetail,
    name: '/sourceSystemDetail',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Source SystemDetail',
      mid: 'c2a8-4f9b',
    },
  },
  {
    path: 'metaModel',
    component: MetaModel,
    name: '/metaModel',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Meta Model',
      mid: '8b3e-0d67',
    },
  },
  {
    path: 'MetadataStandards',
    component: dataStandards,
    name: '/MetadataStandards',
    key: '/dataStandards',
    meta: {
      ownType: 'Metadata',
      mid: '5a9f-c1e4',
    },
  },
  {
    path: 'chartsMap',
    component: DataMapV2,
    name: '/chartsMap',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Data Map',
      mid: 'd3b6-8a05',
    },
  },
  {
    path: 'dataMapV2',
    component: DataMapV2,
    name: '/dataMapV2',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'dataMapV2',
      mid: '9f0c-4e72',
    },
  },
  {
    path: 'metaDataDataBase',
    component: DataBase,
    name: '/metaDataDataBase',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Database',
      mid: '6c2a-b9d1',
    },
  },
  {
    path: 'metaDataDataBaseDetail',
    component: DataBaseDetail,
    name: '/metaDataDataBaseDetail',
    meta: {
      ownType: 'Metadata',
      labelTitle: 'DataBase',
      mid: 'a7d4-0f8e',
    },
  },
  {
    path: 'metaDataTable',
    component: MetaDataTable,
    name: '/metaDataTable',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Table',
      mid: '1b69-e5c2',
    },
  },
  {
    path: 'metaDataTableDetail',
    component: MetaDataTableDetail,
    name: '/metaDataTableDetail',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Table',
      mid: 'f4d8-2a07',
    },
  },
  {
    path: 'dataassetDetail',
    component: DataAssetDetail,
    name: '/dataassetDetail',
    meta: {
      ownType: 'Metadata',
      lableTitle: 'Table',
      mid: '3e9b-6c14',
    },
  },
];

export default MetaRouteList;
